import { useMutation } from '@tanstack/react-query';
import { getTheme } from '../queries/themes';

export function useEssayTheme() {
  const { mutate } = useMutation({
    mutationKey: ['getTheme'],
    mutationFn: (slug: string) => getTheme(slug),
    retry: false
  })
  
  return { mutate }
}